module.exports = __webpack_public_path__ + "img/icon-download.a1762467.svg";